"use client";
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import {Img} from "@/components/Img";
import reactHtmlParser from "react-html-parser";

const MyComponent = ({img, title, deg}) => {
    return (
        <StyledComponent className={'team-single'}>

            <div className="team-single__img">
                <Img transition src={img} alt={reactHtmlParser(title)}/>
            </div>
            <div className="team-single__content">
                <h4 className={'split-up'}>{reactHtmlParser(title)}</h4>
                <p className={'split-up'}>{reactHtmlParser(deg)}</p>

            </div>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  //margin-bottom: 80px;
  position: relative;
  cursor: pointer;

    
  .team-single__img {
    position: relative;
    padding-top: calc(350 / 270 * 100%);
    overflow: hidden;
  }

  .team-single__content {
    margin-top: 20px;

    h4 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      color: #191919;
    }

    p {
      color: rgba(25,25,25,0.5);
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
    }
  }

  &:hover {
    .team-single__img img {
      transform: scale(1.04);
    }
  }
`;

export default MyComponent;
